import Tooltip from 'tooltip.js';

const tooltipContainer = document.querySelector('.ui-tooltips');

export function initTooltips() {
  const stuffToTip = document.querySelectorAll('.js-ui-tooltip');
  stuffToTip.forEach(item => {
    var tip = new Tooltip(item, {
      trigger: 'hover',
      container: tooltipContainer,
      title: item.getAttribute('data-tooltip'),
      placement: 'bottom',
      offset: '0, 4px',
      html: true,
      delay: {
        show: Number(item.getAttribute('data-tooltip-delay')) || 750,
        hide: 0
      },
      boundariesElement: document.body
    });
    item.addEventListener('focus', function () { tip.show(); });
    item.addEventListener('blur', function () { tip.hide(); });
    item.removeAttribute('data-tooltip');
    item.classList.remove('js-ui-tooltip');
  });
}

// Make initTooltips available globally
if (!window.ui) window.ui = {};
window.ui.initTooltips = initTooltips;

// Optionally auto-initialize on import
initTooltips();
